import React, { useEffect, useState } from "react";
import {
  getnewfilterdata,
  custom_api_call,
  getfilterValuesDropDown,
} from "../Api";
import { getCustomApiCall } from 'api/AudienceApi'

const Modal_conditions = (props) => {
  const [filterPropertiesDropDown, setfilterPropertiesDropDown] = useState([]);
  const [filterValuesDropDown, setfilterValuesDropDown] = useState([]);
  const [category, setCategory] = useState([]);
  const [anyOrAll, setAnyOrAll] = useState("OR");
  const [filters, setfilters] = useState([
    {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      filterValue: null,
      sequenceNo: 1,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      inputBox: false,
      selectedIndex: 0,
      filterParameters: [],
    },
  ]);
  useEffect(() => {
    getConditions();
    sessionStorage.setItem("metadatainfo", JSON.stringify(props.metaDataInfo));
  }, []);
  const getConditions = () => {

    getnewfilterdata()
      .then((data) => {
        var value_arr = [];
        var key_arr = [];
        var resdata = data;
        var index = 0;
            console.log("ffffgggg",data)

        resdata &&
          Object.keys(resdata).forEach((key) => {
            key_arr.push(key);

            resdata[key].filterProperties.map((val) => {
              val.index = index;
              value_arr.push(val);
              index++;
            });
          });

        setCategory(key_arr);
        setfilterPropertiesDropDown(value_arr || []);
        props.ModalType.isediting && props.ModalType.isediting == true
          ? presetFilterValues(value_arr)
          : props.handlemodalLoader(false);
      })
      .catch((e) => { })
  };

  function presetFilterValues(value_arr) {
    console.log("vgggg",props.ModalType.conditions)
    let temp = [...props.ModalType.conditions];

    if (props.ModalType.conditions) {
      if (
        props.ModalType.isediting == true &&
        props.ModalType.conditions.length > 0
      ) {


        props.ModalType.conditions &&
          props.ModalType.conditions.map((val, idx) => {
            // temp.push(val);


            var data = value_arr.filter((obj) => {
              if (obj.id == val.filterPropertyId) {

                if (obj.parameters[0] && val.filterParameters[0]) {
                  obj.parameters[0].value = val.filterParameters[0].value;
                }
                if (obj.parameters[1] && val.filterParameters[1]) {
                  obj.parameters[1].value = val.filterParameters[1].value;
                }
                return obj;
              }
            });

            console.log("data-val", val, filterValuesDropDown,filterPropertiesDropDown);

            temp[idx].id1 = data[0].index;
            temp[idx].id2 = 0;
            temp[idx].selectedIndex = data[0].index + 1;
            temp[idx].filterValue = val.filterValue;

            if (data[0].fieldToSave) {
              temp[idx].fieldToSave = data[0].fieldToSave;
              temp[idx].fieldToShow = data[0].fieldToShow;
            }
            if (val.filterParameters.length > 0) {
              temp[idx].filterParameters[0].value = data[idx].parameters[0].value;
            }

            //TODO : Check here or verify the logic
            let filteredValue2 =
              value_arr[data[0].index].filterActions[0].filterValueType;

            filteredValue2.type === "predefined"
              ? (temp[idx].inputBox = false)
              : (temp[idx].inputBox = true);

            filterValuesDropDownAPI(data[0].index + 1, value_arr);

            if (value_arr[data[0].index].parameters.length > 0) {
              value_arr[data[0].index].parameters.map(async (param, id) => {
                let url = param.api;

                temp[idx].filterParameters[id] = {
                  ...param,
                  filterPropertyParameterId: param.id,
                  dropData: [],
                };
                if (param.inputType === "dropdown") {
                  custom_api_call(url.slice(1))
                    .then((dd) => {
                      temp[idx].filterParameters[id].dropData = dd;
                      val.filterParameters &&
                        val.filterParameters.map((obj, id) => {
                          if(data[idx] && data[idx].parameters && data[idx].parameters[id] && data[idx].parameters[id].value){
                            temp[idx].filterParameters[id].value = data[idx].parameters[id].value;

                          }
                          if (obj.val) {
                            temp[idx].filterParameters[id].value = obj.value;
                          }
                           if (obj.value) {
                            temp[idx].filterParameters[id].value = obj.value;
                          }
                          console.log("ertttt",obj,id ,idx ,data)

                        });

                      createNewFilter();
                      setfilters(temp);
                      props.handlemodalLoader(false);
                    })
                    .catch((e) => { })
                } else {
                  temp[idx].filterParameters[id].dropData = [];

                }
              });
            }


          });
          setAnyOrAll( temp[0].logicalOperator)
        setfilters(temp);
        props.handlemodalLoader(false);
        props.condition_data(temp);
      }
    }
  }

  const filterValuesDropDownAPI = (key, arr) => {

    const url =
    filterPropertiesDropDown && filterPropertiesDropDown.length > 0  && filterPropertiesDropDown[key - 1].api
        ? filterPropertiesDropDown[key - 1].api.slice(1)
        : (arr && arr[key - 1] && arr[key - 1].api && arr[key - 1].api.slice(1));

    url &&
      getfilterValuesDropDown(url)
        .then((data) => {
          setfilterValuesDropDown(data);
        })
        .catch((e) => { })
  };

  const handleFilterPropertyChange = async (e, filtIndex) => {

    let key = e.target.selectedIndex;
    let name = e.target.name;
    let sequence = e.target.selectedIndex;


    e.preventDefault();

    if (e.target.value != "-1") {
      if (sequence !== -1) {
        let temp = [...filters];
        temp[filtIndex].filterPropertyId = e.target.value || "";
        temp[filtIndex].id1 =
          (await e.target.selectedOptions[0].index) - 1 || 0;
        let filteredValue =
          filterPropertiesDropDown[filters[filtIndex].id1].filterActions[0]
            .filterValueType;
        temp[filtIndex].filterValueTypeId = filteredValue.id;
        temp[filtIndex].filterPropertyName = name || "Select";
        // temp[filtIndex].filterActionId =
        //   filterPropertiesDropDown[filters[filtIndex].id1].filterActions[0].id;
        temp[filtIndex].id2 = 0;
        temp[filtIndex].selectedIndex = key;
        temp[filtIndex].fieldToShow =
          filterPropertiesDropDown[filters[filtIndex].id1].fieldToShow ||
          "name";
        temp[filtIndex].fieldToSave =
          filterPropertiesDropDown[filters[filtIndex].id1].fieldToSave || "id";

        //check and set the input type to 'inputBox' ||'Dropdown'

        temp[filtIndex].staticOptions =  filterPropertiesDropDown[filters[filtIndex].id1].staticOptions &&  filterPropertiesDropDown[filters[filtIndex].id1].staticOptions.length > 0?  filterPropertiesDropDown[filters[filtIndex].id1].staticOptions: null

        filteredValue.type === "predefined"
          ? (temp[filtIndex].inputBox = false)
          : (temp[filtIndex].inputBox = true);
        //check if parameters are present and map them .
        if (filterPropertiesDropDown[key - 1].parameters.length > 0) {
          filterPropertiesDropDown[key - 1].parameters.map(
            async (param, id) => {
              let url = param.api;
              // let tempArr = [...isParameter]
              // tempArr[id] = param
              temp[filtIndex].filterParameters[id] = {
                ...param,
                filterPropertyParameterId: param.id,
                value: null,
                dropData: [],
              };
              if (param.inputType === "dropdown") {
                // tempArr[id].dropData = []
                custom_api_call(url.slice(1))
                  .then((data) => {
                    temp[filtIndex].filterParameters[id].dropData = data;
                  })
                  .catch((e) => { })
              } else {
                temp[filtIndex].filterParameters[id].dropData = [];
              }
            }
          );
        } else {
          temp[filtIndex].filterParameters = [];
        }
        if (filteredValue.type == "predefined") {
          filterValuesDropDownAPI(key);
        }
        setfilters(temp);
        props.condition_data(temp);
      }
    } else {
      let temp = [...filters];
      temp[filtIndex].filterPropertyId = "";
      temp[filtIndex].id1 = 0;
    }
  };

  const setIntialAction= (filtIndex)=>{
    let temp = [...filters];

    let ridx = temp[filtIndex].id1
    console.log(filterPropertiesDropDown)

    let id = filterPropertiesDropDown[ridx].filterActions[0].id
    let value = filterPropertiesDropDown[ridx].filterActions[0].name
    let type = filterPropertiesDropDown[ridx].filterActions[0].type



    //set filtervalue
    temp[filtIndex].id2 = 0;



    let filteredValue =
    filterPropertiesDropDown[filters[filtIndex].id1].filterActions[0]
      .filterValueType;
  temp[filtIndex].filterActionId = id;
  //set filtervalue
  temp[filtIndex].filterValueTypeId = filteredValue.id;
  temp[filtIndex].filterActionName = value;


    // //check and set the input type to 'inputBox' ||'Dropdown'
    filteredValue.type === "predefined"
      ? (temp[filtIndex].inputBox = false)
      : (temp[filtIndex].inputBox = true);

      console.log("POEOOOOOOOOO",id,value,type, filteredValue ,temp)

    setfilters(temp);
    props.condition_data(temp);
  }

  const handleFilterActionChange = (e, filtIndex, xx=null) => {
    let name = xx? "is": e.target.name ;
    let sequence = xx? xx : e.target.selectedIndex;

    console.log("LOPPPPPPPPPPPPPPPPPPPPPPP", name,sequence,xx)

    if(!xx)
      e.preventDefault();
    if (sequence !== 0) {
      let event = e.target;
      let id2 = event.selectedOptions[0].index - 1;
      let temp = [...filters];

      let filteredValue =
        filterPropertiesDropDown[filters[filtIndex].id1].filterActions[id2]
          .filterValueType;
      temp[filtIndex].filterActionId = event.value || "";
      temp[filtIndex].id2 = id2;
      //set filtervalue
      temp[filtIndex].filterValueTypeId = filteredValue.id;
      temp[filtIndex].filterActionName = name || "Select";
      //check and set the input type to 'inputBox' ||'Dropdown'
      filteredValue.type === "predefined"
        ? (temp[filtIndex].inputBox = false)
        : (temp[filtIndex].inputBox = true);

      setfilters(temp);
      props.condition_data(temp);
    }
  };

  const handleFilterValueChange = (e, filtIndex) => {
    e.preventDefault();
    let sequence = e.target.selectedIndex;


    if (sequence !== 0) {
      let event = e.target;
      let temp = [...filters];
      temp[filtIndex].filterValue = event.value || "";


      setfilters(temp);
      props.condition_data(temp);
    }
  };

  //set or/any to filters Array
  const handleAnyOr = (e) => {
    let value = e.target.value;
    setAnyOrAll(value || "");
    let temp = [...filters];
    temp.map((obj, id) => {
      obj.logicalOperator = value || "";
    });
    setfilters(temp);
    props.condition_data(temp);
  };

  const createNewFilter = () => {
    let id = filters.length - 1;
    let sequence = filters[id].sequenceNo + 1;
    let temp = [...filters];
    let objToBeAdded = {
      filterPropertyId: null,
      filterActionId: null,
      filterValueTypeId: null,
      filterValue: null,
      sequenceNo: 1,
      logicalOperator: anyOrAll,
      id1: 0,
      id2: 0,
      inputBox: false,
      selectedIndex: 0,
      filterParameters: [],
    };
    temp.push(objToBeAdded);
    setfilters(temp);
    props.condition_data(temp);
  };

  const deleteFilter = (id) => {
    const toBeDeleted = [...filters];
    //

    toBeDeleted.splice(id, 1);
    setfilters(toBeDeleted);
    props.condition_data(toBeDeleted);
  };

  return (
    <>
      {/* {filters[0] && filters[0].logicalOperator &&setAnyOrAll( filters[0].logicalOperator)} */}
      <div className="condition-section">
        {props.metaDataInfo.serviceName == "IfElseService" ? (
          <h4 className="h4">Select one or more conditions :</h4>
        ) : props.metaDataInfo.serviceName == "WaitService" ? <h4 className="h4">Exit Wait When:</h4> : (
          <h4 className="h4">Advanced Filters:</h4>
        )}
        <div className="conditions">
          <br />
          <div className="contactMatch">
            <p className="contactMatchText">
              Contact Match
              <select
                onChange={(e) => handleAnyOr(e)}
                id="anyOrand"
                value={anyOrAll}
              //  className="kwDesign1 w69"
              >
                <option value="OR">Any</option>
                <option value="AND">All</option>
              </select>
              of the following conditions.
            </p>
            <div className="addRemoveDetails">
              {filters &&
                filters.map((filtObj, filtId) => {
                  const parentId = filtObj.id1;
                  const isActive = filtId === 0 ? true : false;
                  //@Boney: Filter options Component starts here

                  return (
                    <ul key={filtId} id="container" className="conditions-map">
                      <li>
                        <ul
                          className="d-flex align-items-center flex-wrap"
                          style={{ paddingLeft: "0px" }}
                        >
                          <li>
                            <a
                              to=""
                              disabled={isActive}
                              style={{ margin: "1vh" }}
                              onClick={() => deleteFilter(filtId)}
                              className="minusBtn"
                            >
                              <span className="icon-Group-271"></span>
                            </a>
                          </li>
                          {/* Filter no.1  */}
                          <li>
                            <select
                              onChange={(e) => {
                                if (e.target.value != -1) {
                                  handleFilterPropertyChange(e, filtId);
                                } else {

                                  handleFilterPropertyChange(e, filtId);
                                }
                                setTimeout(()=>{setIntialAction( filtId )},1000) 

                              }}
                              id="drop1"
                              value={filters[filtId].filterPropertyId}
                            >
                              <option value={-1} id="0">
                                Select
                              </option>
                              {category &&
                                category.map((val) => {
                                  return (
                                    <optgroup label={val}>
                                      {filterPropertiesDropDown
                                        ? filterPropertiesDropDown.map(
                                          (val2) => {
                                            if (val2.category === val) {
                                              return (
                                                <option
                                                  key={val2.index}
                                                  id={val2.index}
                                                  value={val2.id}
                                                >
                                                  {val2.name}
                                                </option>
                                              );
                                            }
                                          }
                                        )
                                        : ""}
                                    </optgroup>
                                  );
                                })}
                            </select>
                          </li>

                             {/* Filter no.4 */}
                          {/* if parameter is present then show params */}
                          {/* if dropdown is present else textbox will appear */}

                          {filters[filtId].filterParameters &&
                            filters[filtId].filterParameters.length > 0 &&
                            filters[filtId].filterParameters.map(
                              (data, index) => {
                                console.log("hghg",data)

                                let keyToSave = filters[filtId].filterParameters[index].fieldToSave
                                let keyToShow = filters[filtId].filterParameters[index].fieldToShow
                                if( filters[filtId].filterParameters[index].value && data.api && data.api.includes( '/personal/eventTypes?category=') && filters[filtId].filterParameters[index+1] 
                                  && filters[filtId].filterParameters[index+1].dropData && !filters[filtId].filterParameters[index+1].dropData.length
                                  ){
                                   getCustomApiCall(`eventDefinitions/${filters[filtId].filterParameters[index].value}/schema`).then(res=>{
                                                    res.data.map(obj=> obj.id = obj.key)
                                                    let t = [...filters];
                                                    t[filtId].filterParameters[1].dropData = res.data;

                                                    console.log("ppppr",t)
                                                    setfilters(t);
                                                    props.condition_data(t);
                                                  
                                                  })
                                }

                                return data.inputType === "dropdown" ? (
                                  <li>
                                    <select
                                      onChange={(e) => {
                                        let temp = [...filters];
                                        let sequence = e.target.selectedIndex;
                                        if (sequence !== 0) {
                                          temp[filtId].filterParameters[
                                            index
                                          ].value = e.target.value;

                                          setfilters(temp);
                                          props.condition_data(temp);
                                        }

                                        if(data.api && data.api.includes('/personal/eventTypes?category=') && temp[filtId].filterParameters[index+1] ){
                                                   let val = e.target.value
                                                  getCustomApiCall(`eventDefinitions/${val}/schema`).then(res=>{
                                                    res.data.map(obj=> obj.id = obj.key)
                                                    let t = [...filters];
                                                    t[filtId].filterParameters[1].dropData = res.data;
                                                    console.log("ppppr",t[filtId].filterParameters[1])
                                                    setfilters(t);


                                                  });


                                        }

                                      }}
                                      id="drop1"
                                      value={
                                        filters[filtId].filterParameters[index]
                                          .value
                                      }
                                    // className="kwDesign2"
                                    // required={!data.isOptional}
                                    >
                                      <option value="0" id="0">
                                        Select
                                      </option>
                                      {data.dropData && data.dropData.length > 0
                                        ? data.dropData.map((obj, objId) => (
                                          <option
                                            key={index}
                                            id={objId}
                                            value={obj.id || obj[keyToSave]}
                                          >
                                            {obj.name || obj[keyToShow] }
                                          </option>
                                        ))
                                        : ""}
                                    </select>
                                  </li>
                                ) : (
                                  <li>
                                    {/* textbox for parameters */}

                                    <input
                                      type="text"
                                      placeholder={data.name}
                                      pattern="^\{\{[a-zA-Z_]+[0-9]?(\.[a-zA-Z_]+[0-9]?)+\}\}$|([A-Za-z0-9_@. ]{1,}|\{[A-Za-z0-9_@.]{1,}\})|(.+)"
                                      title=""
                                      onChange={(e) => {
                                        let temp = [...filters];
                                        temp[filtId].filterParameters[
                                          index
                                        ].value = e.target.value;
                                        setfilters(temp);
                                        props.condition_data(temp);
                                      }}
                                    />
                                  </li>
                                );
                              }
                            )}
                          {/* 2nd filter starts */}
                          <li>
                            <select
                              onChange={(e) =>
                                handleFilterActionChange(e, filtId)
                              }
                              id="drop2"
                              // className="kwDesign2"
                              value={filters[filtId].filterActionId}
                            >
                              <option value="-1" id="0">
                                Select
                              </option>
                              {filterPropertiesDropDown[parentId]
                                ? filterPropertiesDropDown[
                                  parentId
                                ].filterActions.map((data, index) => (
                                  <option
                                    key={index}
                                    id={index}
                                    value={data.id}
                                  >
                                    {data.name}
                                  </option>
                                ))
                                : ""}
                            </select>
                          </li>
                          {/* 3rd filter starts */}

                          <li>
                          {console.log("filters-val", filterPropertiesDropDown,filterPropertiesDropDown.find(o=>o.id ==filters[filtId].filterPropertyId))}
                            {console.log("filters ppppp", filters)}
                            {filters[filtId].inputBox ? (
                              <input
                                name={filters[filtId].filterValueTypeId || ""}
                                id="input1"
                                // className="kwDesign"
                                type="text"
                                value={filters[filtId].filterValue}
                                pattern="^\{\{[a-zA-Z_]+[0-9]?(\.[a-zA-Z_]+[0-9]?)+\}\}$|([A-Za-z0-9_@. ]{1,}|\{[A-Za-z0-9_@.]{1,}\})|(.+)"
                                title=""
                                onChange={(e) =>
                                  handleFilterValueChange(e, filtId)
                                }
                              />
                            ) :  filters[filtId].staticOptions || filterPropertiesDropDown.find(o=>o.id ==filters[filtId].filterPropertyId)?.staticOptions ?<>
                        
                         <select
                                id="drop3"
                                //  className="kwDesign2"
                                value={filters[filtId].filterValue}
                                onChange={(e) =>
                                  handleFilterValueChange(e, filtId)
                                }
                              >
                                <option value="-1" id="0">
                                  Select
                                </option>
                                
                                {(filters[filtId].staticOptions|| filterPropertiesDropDown.find(o=>o.id ==filters[filtId].filterPropertyId)?.staticOptions)
                                  ? (filters[filtId].staticOptions|| filterPropertiesDropDown.find(o=>o.id ==filters[filtId].filterPropertyId)?.staticOptions).map((data, index) => {
                                    let fieldToSave =
                                      filters[filtId].fieldToSave || "id";
                                    let fieldToShow =
                                      filters[filtId].fieldToShow || "name";

                                    return (
                                      <option
                                        key={index}
                                        name={data.id}
                                        id={index}
                                        value={data[fieldToSave]}
                                      >
                                        {data[fieldToShow]}
                                      </option>
                                    );
                                  })
                                  : ""}
                              </select>
                            
                            </> : (
                              <select
                                id="drop3"
                                //  className="kwDesign2"
                                value={filters[filtId].filterValue}
                                onChange={(e) =>
                                  handleFilterValueChange(e, filtId)
                                }
                              >
                                <option value="-1" id="0">
                                  Select
                                </option>
                                {filterValuesDropDown
                                  ? filterValuesDropDown.map((data, index) => {
                                    let fieldToSave =
                                      filters[filtId].fieldToSave || "id";
                                    let fieldToShow =
                                      filters[filtId].fieldToShow || "name";

                                    return (
                                      <option
                                        key={index}
                                        name={data.id}
                                        id={index}
                                        value={data[fieldToSave]}
                                      >
                                        {data[fieldToShow]}
                                      </option>
                                    );
                                  })
                                  : ""}
                              </select>
                            )}
                          </li>
                       
                          <div id="anyOr">{anyOrAll}</div>
                        </ul>
                      </li>
                    </ul>
                  );
                })}
              <div className="addNewButton" style={{ marginLeft: "0.5em" }}>
                <a to="" onClick={createNewFilter} className="plusIconText">
                  <span className="icon-Group-272" /> Add New
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal_conditions;
